import "../../assets/css/admin.css";
import React, { useEffect } from "react";
import { animation, headerSet } from "../../Helper/CssHelper";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import HeaderEdit from "./AdminPages/HeaderEdit";
import AboutMeEdit from "./AdminPages/AboutMeEdit";
import ResumeEdit from "./AdminPages/ResumeEdit";
import ThemeEdit from "./AdminPages/ThemeEdit";
import ProjectsEdit from "./AdminPages/ProjectsEdit";
import CertificationsEdit from "./AdminPages/CertificationsEdit";

function Dashboard(props) {
  const HeaderData = props.HeaderData;
  const AboutMeData = props.AboutMeData;
  const ResumeData = props.ResumeData;
  const ThemeData = props.ThemeData;
  const ProjectsData = props.ProjectsData;
  const CertificationsData = props.CertificationsData
  // console.log(props);

  useEffect(() => {
    headerSet("Dashboard | Justin Dsouza");
    // showNavLink('home','admin-section')
    animation("admin-section");
  }, []);
  return (
    <section id="admin-section" className="admin section-show ">
      <div className="container">
        <div className="ratio ratio-16x9 m-2 d-none d-lg-block">
          <iframe
            id="WebsitePreview"
            src="https://justin-dsouza.web.app/"
            style={{ borderRadius: "50px" }}
            allowFullScreen
            title="Website Preview"
          ></iframe>
        </div>
        <Tabs
          defaultActiveKey="HeaderData"
          transition={false}
          id="noanim-tab-example"
          className="mb-3 d-flex justify-content-lg-start justify-content-evenly"
          variant="pills"
        >
          <Tab eventKey="HeaderData" title="HeaderData">
            <HeaderEdit HeaderData={HeaderData} />
          </Tab>
          <Tab eventKey="AboutMeData" title="AboutMeData">
            <AboutMeEdit AboutMeData={AboutMeData} />
          </Tab>
          <Tab eventKey="ResumeData" title="ResumeData">
            <ResumeEdit ResumeData={ResumeData} />
          </Tab>
          <Tab eventKey="Projects" title="Projects">
            <ProjectsEdit ProjectsData={ProjectsData}/>
          </Tab>
          <Tab eventKey="Certifications" title="Certifications">
            <CertificationsEdit CertificationsData={CertificationsData}/>
          </Tab>
          <Tab eventKey="Theme" title="Theme">
            <ThemeEdit ThemeData={ThemeData} />
          </Tab>
        </Tabs>
      </div>
    </section>
  );
}

export default Dashboard;
